import { Strings } from '../../../../utils/resources/strings';
import { CRBTUIViewImpl } from '../crbt/crbtuiview';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { UIComponentHandler } from '../../../toolkit/uicomponent';
import { BlacklistComponentProps, BlacklistComponentState , BlacklistHandler } from './blacklistcomponent';
import { BlacklistCSSStyle } from './blacklistcss';
import * as React from 'react';
import { MemberDetailsDtoImpl, MemberDetailsDto } from 'src/com/sixdee/crbtportal/core/dto/listtones/memberdetailsdto';
import { ManageGroupType } from '../groups/managegroup/managegrouptype';
import { BlacklistDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/blacklist/blacklistdto';
import { ListBlackListComponent } from './blacklisting/listblacklistcomponent';
import { ManageBlacklistComponent } from './manageblacklist/manageblacklistcomponent';
// import { ManageBlacklistComponent } from './managegroup/managegroupcomponent';


export class BlacklistViewImpl extends CRBTUIViewImpl
{
    private listOfBlacklistMembers:MemberDetailsDto[];
    constructor(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler)
    {
        super(applicationContext, uiComponentHandler);
    }
    
    bindHandlers()
    {
        this.onCancelClicked = this.onCancelClicked.bind(this);
        this.onADDNumberClicked = this.onADDNumberClicked.bind(this);
    }

    getChildComponent(props: BlacklistComponentProps, state: BlacklistComponentState, cssStyle: BlacklistCSSStyle): JSX.Element
    {   
        return (
            <>
            {state.manageBlacklistType === ManageGroupType.LIST && <ListBlackListComponent onAddNumberClicked={this.onADDNumberClicked} context={props.context}/>}        

            {/* {state.manageBlacklistType === ManageGroupType.CREATE && <ManageBlacklistComponent listOfBlacklistMembers={this.listOfBlacklistMembers} blacklistDto={this.getCreateBlacklistDto()} onCancelClicked={this.onCancelClicked} manageBlacklistType={state.manageBlacklistType} context={props.context}/>} */}
            {state.manageBlacklistType === ManageGroupType.CREATE && <ManageBlacklistComponent listOfBlacklistMembers={this.listOfBlacklistMembers} blacklistDto={this.getCreateBlacklistDto()} onCancelClicked={this.onCancelClicked} manageBlacklistType={state.manageBlacklistType} context={props.context}/>}

            </>
        );
    }

    getNavigationPath()
    {
        return [this.getUIProps().context.getResources().getString(Strings.myaccount),
             this.getUIProps().context.getResources().getString(Strings.blacklist)];
    }

    getBannerImg()
    {
        return "categories.jpg";
    }

    private onADDNumberClicked(listOfBlacklistMembers:MemberDetailsDto[])
    {
        this.listOfBlacklistMembers = listOfBlacklistMembers;
        (this.getUIComponentHandler() as BlacklistHandler).updateType(ManageGroupType.CREATE, this.getCreateBlacklistDto());
    }
    
    private onCancelClicked()
    {
        (this.getUIComponentHandler() as BlacklistHandler).updateType(ManageGroupType.LIST, (this.getUIState() as BlacklistComponentState).blacklistDto);
    }

    // private getBlacklistDto()
    // {
    //     let groupDto = new BlacklistDtoImpl();
    //     groupDto.setBlacklistName("Test Blacklist");

    //     let member1 = new MemberDetailsDtoImpl();
    //     member1.setMemberName("Test1");
    //     member1.setMsisdn("1234567890");

    //     let member2 = new MemberDetailsDtoImpl();
    //     member2.setMemberName("Test2");
    //     member2.setMsisdn("0987654321");

    //     let member3 = new MemberDetailsDtoImpl();
    //     member3.setMemberName("Test3");
    //     member3.setMsisdn("77863488445");

    //     let member4 = new MemberDetailsDtoImpl();
    //     member4.setMemberName("Test4");
    //     member4.setMsisdn("9876543212");
    //     groupDto.setMembersList([new MemberDetailsDtoImpl(), member1, member2,member3, member4]);

    //     return groupDto;
    // }

    private getCreateBlacklistDto()
    {
        let groupDto = new BlacklistDtoImpl();
        groupDto.setBlacklistName("");
       
        groupDto.setMembersList([new MemberDetailsDtoImpl()]);

        return groupDto;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/blacklist/blacklistview.tsx